import React, { FC } from 'react';
import { useQuery } from 'react-query';
import RequirableSelect from '../RequireableSelect';
import { Module } from './types';

interface SubsouceSelectFormGroupProps {
  subsourceId: number | undefined;
  selectedModuleId: number | undefined;
  formIndex: string;
  studentId: string;
  includeModuleIds: number[];
  onChange: (moduleId: number) => void;
  overrideFormName: string;
}

const ModuleelectFormGroup: FC<SubsouceSelectFormGroupProps> = ({
  formIndex,
  subsourceId,
  selectedModuleId,
  includeModuleIds,
  studentId,
  onChange,
    overrideFormName,
}) => {
  const { isLoading, data, error } = useQuery<any, Error, Module[]>(
    `subsource-${subsourceId}-modules`,
    async () => {
      const queryStringParts = includeModuleIds.map(id => `include_ids=${id}`);
      if (studentId !== undefined) {
        queryStringParts.push(`student_id=${studentId}`);
      }
      return $.get(`/admin/api/subsource/${subsourceId}/modules`, queryStringParts.join('&'));
    },
    {
      enabled: !!subsourceId,
    },
  );

  const moduleOpts = (data || []).map((mod) => {
    const shouldShowReviewStatus = mod.review_status !== 'NEW' && mod.review_status !== 'NONE';
    const statusPrefix = shouldShowReviewStatus ? `[${mod.review_status}] ` : '';
    return ({
      label: statusPrefix + mod.title_en,
      value: mod.id,
    });
  });
  let formName = 'module_instances';
  if (overrideFormName !== undefined) {
    formName = overrideFormName;
  }

  return (
    <div className="form-group">
      <label htmlFor={`${formName}-${formIndex}-module`}>MODULE</label>
      <RequirableSelect
        onChange={(evt) => onChange(evt.value)}
        isSearchable
        required
        options={moduleOpts}
        name={`${formName}-${formIndex}-module`}
        inputId={`${formName}-${formIndex}-module`}
        value={moduleOpts.find(opt => opt.value === selectedModuleId) ?? null}
        isLoading={isLoading}
      />
      {error && <span>Error: {error.message}</span>}
    </div>
  );
};

export default ModuleelectFormGroup;
